module.exports = __webpack_public_path__ + "img/tipology_mail.115d307d.png";